<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <eps-header :drawer="$store.state.drawer"></eps-header>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Analytical Dashboard</v-toolbar-title>
                <v-divider color="white" class="mx-4" inset vertical></v-divider>
                <v-toolbar-title>{{ selectedModule }}</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <!-- learner selection -->
            <v-row justify="center">
                <v-col cols="12" sm="4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list"
                        item-text="learner" item-value="id" label="Child" outlined persistent-hint
                        hint="Please Select Child" />
                </v-col>
                <v-col cols="12" sm="2" v-if="child">
                    <v-btn color="info" @click="fetchData()">Fetch</v-btn>
                </v-col>
            </v-row>
            <!-- modules -->
            <v-row v-if="modules">
                <v-col cols="3" v-model="modules">
                    <v-card class="mx-10 d-flex flex-column align-center" max-width="174" :style="{
                        backgroundColor: selectedModule === 'Examination' ? '#4527A0' : '#9575CD',
                        color: selectedModule === 'Examination' ? '#fff' : '#fff'
                    }" hover v-model="examination" @click="updateTitle('Examination'); getStudStd()">
                        <v-icon left size="45px" class="pt-3"
                            :style="{ color: selectedModule === 'Examination' ? '#fff' : '#fff' }">mdi-note-text</v-icon>
                        <v-card-title class="pt-0" style="text-align: center;">
                            Examination
                        </v-card-title>
                    </v-card>
                    <br />
                    <v-card class="mx-10 d-flex flex-column align-center" max-width="174" :style="{
                        backgroundColor: selectedModule === 'Attendance' ? '#4527A0' : '#9575CD',
                        color: selectedModule === 'Attendance' ? '#fff' : '#fff'
                    }" hover v-model="attendance" @click="updateTitle('Attendance'); getStudentAttendanceData()">
                        <v-icon left size="45px" :style="{ color: selectedModule === 'Attendance' ? '#fff' : '#fff' }"
                            class="pt-3">mdi-account-multiple-check</v-icon>
                        <v-card-title class="pt-0" style="text-align: center;">
                            Attendance
                        </v-card-title>
                    </v-card>
                    <br />
                    <v-card class="mx-10 d-flex flex-column align-center" max-width="174" :style="{
                        backgroundColor: selectedModule === 'Quiz' ? '#4527A0' : '#9575CD',
                        color: selectedModule === 'Quiz' ? '#fff' : '#fff'
                    }" hover v-model="quiz" @click="updateTitle('Quiz'); getStudentQuizData()">
                        <v-icon left size="45px" class="pt-3"
                            :style="{ color: selectedModule === 'Quiz' ? '#fff' : '#fff' }"> mdi-timetable</v-icon>
                        <v-card-title class="pt-0" style="text-align: center;">
                            Quiz
                        </v-card-title>
                    </v-card>
                    <br />
                    <v-card class="mx-10 d-flex flex-column align-center" max-width="174" :style="{
                        backgroundColor: selectedModule === 'Homework' ? '#4527A0' : '#9575CD',

                    }" hover style="color: white;" v-model="homework"
                        @click="updateTitle('Homework'); getStudentHomeworkData()">
                        <v-icon left size="45px" class="pt-3"
                            :style="{ color: selectedModule === 'Homework' ? '#fff' : '#fff' }">
                            mdi-file-document-edit-outline</v-icon>
                        <v-card-title class="pt-0" style="text-align: center;">
                            Homework
                        </v-card-title>
                    </v-card>
                    <br />
                    <v-card class="mx-10 d-flex flex-column align-center" max-width="174" :style="{
                        backgroundColor: selectedModule === 'Course Framework' ? '#4527A0' : '#9575CD',
                        color: selectedModule === 'Course Framework' ? '#fff' : '#fff'
                    }" hover v-model="courseF" @click="updateTitle('Course Framework'); getStudentCourseData()">
                        <v-icon left size="45px" class="pt-3"
                            :style="{ color: selectedModule === 'Course Framework' ? '#fff' : '#fff' }">
                            mdi-script-text-outline</v-icon>
                        <v-card-title class="pt-0" style="text-align: center;">
                            Course <br />
                            Framework
                        </v-card-title>
                    </v-card>
                    <br />
                    <v-card class="mx-10 d-flex flex-column align-center" max-width="174" :style="{
                        backgroundColor: selectedModule === 'Fees' ? '#4527A0' : '#9575CD',
                        color: selectedModule === 'Fees' ? '#fff' : '#fff'
                    }" hover style="text-align: center;" v-model="fees"
                        @click="updateTitle('Fees'); getStudentFeesData()">
                        <v-icon left size="45px" class="pt-3"
                            :style="{ color: selectedModule === 'Fees' ? '#fff' : '#fff' }"> mdi-hand-extended</v-icon>
                        <v-card-title class="pt-0" style="text-align: center;">
                            Fees
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col v-if="selectedModule" cols="9">
                    <div v-if="selectedModule == 'Examination'">
                        <v-row>
                            <v-col align="right" cols="3">
                                <v-btn v-model="overall" @click="getStudentExamData()" :loading="loading"
                                    color="warning" elevated><v-icon left>mdi-chart-bar</v-icon>Overall</v-btn>
                            </v-col>
                            <v-col align="left" cols="2">
                                <v-btn v-model="filtered" @click="showFilters" color="warning" elevated><v-icon
                                        left>mdi-filter</v-icon>Filters</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <!-- <v-col align="right" cols="3"><v-btn rounded  color="success" outlined ><v-icon color="success">mdi-export</v-icon>Export</v-btn ></v-col> -->
                        </v-row>
                        <br />
                        <div v-if="overall && examination_graph != ''">
                            <chart style="width: 800px; height: 400px; border: 1px solid grey;" auto-resize
                                :options="option"></chart><br />
                        </div>
                        <div v-if="filtered">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-select :items="standard_list" label="Standard" item-text="standard_name"
                                        return-object outlined dense v-model="ldiv_id"
                                        @change="getStudCrs(ldiv_id)"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-select :items="semester_list" label="Term" item-text="sem" item-value="id"
                                        outlined dense v-model="sem"></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select :items="stud_crs_list" label="Subject" item-text="crs" item-value="cl_id"
                                        outlined dense v-model="stud_crs"></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select :items="assessment_type_list" label="Assessment" item-text="name"
                                        item-value="id" outlined dense v-model="assessment"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn color="indigo darken-1" style="color: white;" v-model="apply5"
                                        @click="getExamData()" :loading="loader">Apply</v-btn>
                                </v-col>
                            </v-row>
                            <div v-if="apply5 && examination_exam_graph != ''">
                                <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize
                                    :options="option_exam"></chart><br />
                            </div>
                            <!-- <div v-if="filtered && grade_bar_graph_details!=''">
                                 <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize :options="option_exam_grade"></chart><br />
                            </div> -->
                        </div>
                    </div>
                    <div v-if="selectedModule == 'Attendance'">
                        <v-row>
                            <v-col align="right" cols="3">
                                <v-btn v-model="overall" @click="getStudentAttendanceData" :loading="loading1"
                                    color="warning" elevated><v-icon left>mdi-chart-bar</v-icon>Overall</v-btn>
                            </v-col>
                            <v-col align="left" cols="2">
                                <v-btn v-model="filtered" @click="showFilters" color="warning" elevated><v-icon
                                        left>mdi-filter</v-icon>Filters</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <!-- <v-col align="right" cols="3"><v-btn rounded  color="success" outlined ><v-icon color="success">mdi-export</v-icon>Export</v-btn ></v-col> -->
                        </v-row>
                        <br />
                        <div v-if="overall">
                            <chart style="width: 800px; height: 400px; border: 1px solid grey;" auto-resize
                                :options="option1"></chart>
                        </div>
                        <div v-if="filtered">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-select :items="student_standard_list" label="Standard" item-text="standard_name"
                                        item-value="ldiv_id" outlined dense v-model="ldiv_id"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2" v-if="tenant == 'wws'">
                                    <v-select :items="assessment_type_list" label="Assessment Type" item-text="name"
                                        item-value="id" outlined dense v-model="assessment"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2" v-else>
                                    <v-select :items="semester_list" label="Term" item-text="sem" item-value="id"
                                        outlined dense v-model="sem"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn color="indigo darken-1" style="color: white;" v-model="apply1"
                                        :loading="loader1" @click="getStudentPieData">Apply</v-btn>
                                </v-col>
                            </v-row>
                            <div v-if="apply1" class="cols-9 align-center d-flex flex-row mt-10">
                                <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize
                                    :options="chart1"></chart>
                                <table style="width: 40%; border-collapse: collapse; margin: 20px 20px;">
                                    <tbody>
                                        <tr>
                                            <th
                                                style="padding: 10px; background-color: #f2f2f2; width: 7%; border: 1px solid black;">
                                                Standard</th>
                                            <td style="padding: 10px; border: 1px solid black;">{{ selectedStandard }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                style="padding: 10px; background-color: #f2f2f2; border: 1px solid black;">
                                                Term</th>
                                            <td style="padding: 10px; border: 1px solid black;">{{ selectedTerm }}</td>
                                        </tr>
                                        <tr>
                                            <th
                                                style="padding: 10px; background-color: #f2f2f2; border: 1px solid black;">
                                                Attendance (Present/Total)</th>
                                            <td style="padding: 10px; border: 1px solid black;">{{ attendanceRatio }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedModule == 'Quiz'">
                        <v-row>
                            <v-col align="right" cols="3">
                                <v-btn v-model="overall" :loading="loading2" @click="getStudentQuizData" color="warning"
                                    elevated><v-icon left>mdi-chart-bar</v-icon>Overall</v-btn>
                            </v-col>
                            <v-col align="left" cols="2">
                                <v-btn v-model="filtered" @click="showFilters" color="warning" elevated><v-icon
                                        left>mdi-filter</v-icon>Filters</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <br />
                        <div v-if="overall">
                            <chart style="width: 800px; height: 400px; border: 1px solid grey;" auto-resize
                                :options="option2"></chart>
                        </div>
                        <div v-if="filtered">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-select :items="student_standard_list" label="Standard" item-text="standard_name"
                                        item-value="ldiv_id" outlined dense v-model="ldiv_id"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-select :items="semester_list" label="Term" item-text="sem" item-value="id"
                                        outlined dense v-model="sem"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn color="indigo darken-1" style="color: white;" v-model="apply2"
                                        @click="getStudentQuizPieData" :loading="loader2">Apply</v-btn>
                                </v-col>
                            </v-row>
                            <div v-if="apply2">
                                <!-- <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize :options="chart2"></chart> -->
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedModule == 'Homework'">
                        <v-row>
                            <v-col align="right" cols="3">
                                <v-btn v-model="overall" :loading="loading3" @click="getStudentHomeworkData"
                                    color="warning" elevated><v-icon left>mdi-chart-bar</v-icon>Overall</v-btn>
                            </v-col>
                            <v-col align="left" cols="2">
                                <v-btn v-model="filtered" @click="showFilters" color="warning" elevated><v-icon
                                        left>mdi-filter</v-icon>Filters</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <br />
                        <div v-if="overall">
                            <chart style="width: 800px; height: 400px; border: 1px solid grey;" auto-resize
                                :options="option3"></chart>
                        </div>
                        <div v-if="filtered">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-select :items="student_standard_list" label="Standard" item-text="standard_name"
                                        item-value="ldiv_id" outlined dense v-model="ldiv_id"
                                        @change="onStandardChange"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-select :items="semester_list" label="Term" item-text="sem" item-value="id"
                                        outlined dense v-model="sem"></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select :items="student_course_list" label="Subject" item-text="course_name"
                                        item-value="col_id" outlined dense v-model="col_id"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn color="indigo darken-1" style="color: white;" v-model="apply3"
                                        @click="getStudentHomeworkPieData" :loading="loader3">Apply</v-btn>
                                </v-col>
                            </v-row>
                            <div v-if="apply3">
                                <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize
                                    :options="chart3"></chart>
                                <br />
                                <h3>Total Homework and completed Homework</h3>
                                <v-simple-table class="mt-4">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th v-for="(course, index) in studentCourseList" :key="'course-'+index">
                                                {{ course.course_name }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><span style="color:#d81159; font-weight:bold;">Obtained Homework</span>
                                            </td>
                                            <td v-for="(item, index) in data" :key="'obtained-'+index">
                                                {{ item.marks_obtained }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span style="color:#218380; font-weight:bold;">Total Homework</span>
                                            </td>
                                            <td v-for="(item, index) in data" :key="'total-'+index">
                                                {{ item.total_homeworks }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <!-- <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize :options="chart3_1"></chart> -->
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedModule == 'Course Framework'">
                        <v-row>
                            <v-col align="right" cols="3">
                                <v-btn v-model="overall" :loading="loading4" @click="getStudentCourseData()"
                                    color="warning" elevated><v-icon left>mdi-chart-bar</v-icon>Overall</v-btn>
                            </v-col>
                            <v-col align="left" cols="2">
                                <v-btn v-model="filtered" @click="showFilters" color="warning" elevated><v-icon
                                        left>mdi-filter</v-icon>Filters</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <br />
                        <div v-if="overall" style="display: flex; align-items: flex-start; gap: 20px;">
                            <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize
                                :options="chart_crs_frm"></chart>
                            <div>
                                <div v-for="(item, index) in course_framework_data" :key="index"
                                    style="display: flex; align-items: center; margin-bottom: 10px;">
                                    <div class="course-box" :style="{ backgroundColor: chart_crs_frm.color[index] }">{{
                                        item.name }} <br> {{ item.value }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="filtered">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-select :items="student_standard_list" label="Standard" item-text="standard_name"
                                        item-value="ldiv_id" outlined dense v-model="ldiv_id"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn color="indigo darken-1" style="color: white;" v-model="apply4"
                                        @click="getAyCourseData()" :loading="loader4">Apply</v-btn>
                                </v-col>
                            </v-row>
                            <!-- <div v-if="apply4">
                                <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize
                                    :options="crs_ay_data"></chart>
                            </div> -->
                            <div v-if="apply4" style="display: flex; align-items: flex-start; gap: 20px;">
                                <chart style=" width: 800px; height: 390px; border: 1px solid grey;" auto-resize
                                    :options="crs_ay_data">
                                </chart>
                                <div>
                                    <div v-for="(item, index) in bar_graph_details" :key="index"
                                        style="display: flex; align-items: center; margin-bottom: 10px;">
                                        <div class="course-box"
                                            :style="{ backgroundColor: chart_crs_frm.color[index] }">
                                            {{ item.name }} <br> {{ item.value }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedModule == 'Fees'">
                        <v-row>
                            <v-col align="right" cols="3">
                                <v-btn v-model="overall" :loading="loading5" @click="getStudentFeesData" color="warning"
                                    elevated><v-icon left>mdi-chart-bar</v-icon>Overall</v-btn>
                            </v-col>
                            <v-col align="left" cols="2">
                                <v-btn v-model="filtered" @click="showFilters" color="warning" :loading="loading5"
                                    elevated><v-icon left>mdi-filter</v-icon>Filters</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <br />
                        <div v-if="overall">
                            <chart style="width: 800px; height: 400px; border: 1px solid grey;" auto-resize
                                :options="option5"></chart>
                        </div>
                        <div v-if="filtered">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-select :items="student_standard_list" label="Standard" item-text="standard_name"
                                        item-value="ldiv_id" outlined dense v-model="ldiv_id"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2" v-if="fees">
                                    <v-select :items="fee_type" label="Fees Type" item-text="name" item-value="id"
                                        outlined dense v-model="feetype"></v-select>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn color="indigo darken-1" style="color: white;" v-model="apply5"
                                        :loading="loader5">Apply</v-btn>
                                </v-col>
                            </v-row>
                            <div v-if="filtered">
                                <chart style="width: 800px; height: 390px; border: 1px solid grey;" auto-resize
                                    :options="chart5"></chart>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import epsHeader from "../shared/UpdatedHeader.vue";
    import axios from "axios";
    export default {
        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,
            child_list: [],
            student_standard_list: [],
            data: [],
            studentCourseList: [],
            semester_list: [],
            student_course_list: [],
            stud_crs_list: [],
            stud_crs: null,
            assessment_type: [
                { id: 1, name: "August" },
                { id: 2, name: "September" },
            ],
            fee_type: [{ id: 1, name: "Regular" }],
            ldiv_id: null,
            sem: null,
            assessment: null,
            col_id: null,
            feetype: "",
            examination: false,
            attendance: false,
            quiz: false,
            homework: false,
            courseF: false,
            fees: false,
            overall: false,
            filtered: false,
            modules: false,
            selectedModule: "",
            child: null,
            apply1: false,
            loader1: false,
            loading1: false,
            apply2: false,
            loader2: false,
            loading2: false,
            apply3: false,
            apply4: false,
            apply5: false,
            loader3: false,
            loading3: false,
            loading5: false,
            course_framework_data: [],
            bar_graph_details: [],
            examination_graph: [],
            examination_exam_graph: [],
            grade_bar_graph_details: [],
            stud_standard_list: [],
            standard_list: [],
            stud_std: null,
            tableData: [],
            attendanceRatio: "",
            selectedTerm: "",
            selectedStandard: "",
            standard_subject_mapping: [],

            chart_crs_frm: {
                title: {
                    text: "Course Distribution",
                    left: "center",
                },
                color: ["#1f139e", "#43bccd", "#413c58", "#f86624", "#f9c80e", "#9bbb59", "#662e9b"],
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                },
                series: [
                    {
                        name: "Access From",
                        type: "pie",
                        top: "10%",
                        data: [

                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            },
            option_exam_grade: {
                title: {
                    text: "Subject Range Anaysis",
                    left: "center",
                },
                color: ["#102b57"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Growth", "Budget 2011", "Budget 2012"],
                    itemGap: 5,
                },
                grid: {
                    top: "12%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 75,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "Student#",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Marks",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        data: [],
                        value: [],
                        type: "bar",
                    },
                ],
            },
            option_exam: {
                title: {
                    text: "Subjectwise Performance",
                    left: "center",
                },
                color: ["#102b57"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Growth", "Budget 2011", "Budget 2012"],
                    itemGap: 5,
                },
                grid: {
                    top: "12%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 75,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "Exam",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Marks",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        data: [],
                        value: [],
                        type: "bar",
                    },
                ],
            },
            option: {
                title: {
                    text: "Overall Exam Performance",
                    left: "center",
                },
                color: ["#102b57"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                        // dataView: {
                        //     show: true,
                        //     title: "Data View",
                        //     readonly: false,
                        // },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Growth", "Budget 2011", "Budget 2012"],
                    itemGap: 5,
                },
                grid: {
                    top: "12%",
                    // left: '1%',
                    // right: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 75,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "AY",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Percentage",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        data: [],
                        value: [],
                        type: "bar",
                    },
                ],
            },
            option_1: {
                title: {
                    text: "Overall Assessmentwise Performance",
                    left: "center",
                },
                color: ["#f86624", "#f9c80e", "#9bbb59", "#662e9b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Class Test 1", "Term 1", "Class Test 2", "Term 2"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: ["Grade I\n2018-19::T1", "Grade I\n2018-19::T2", "Grade II\n2019-20::T1", "Grade II\n2019-20::T2", "Grade III\n2020-21::T1", "Grade III\n2020-21::T2", "Grade IV\n2021-22::T1", "Grade IV\n2021-22::T2"],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Mark in %",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Class Test 1",
                        data: [80, 75, 65, 70, 61, 85, 82, 90],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Term 1",
                        data: [65, 70, 75, 80, 79, 55, 90, 65],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Class Test 2",
                        data: [0, 0, 55, 60, 62, 61, 78, 75],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Term 2",
                        data: [55, 65, 62, 58, 72, 75, 70, 80],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            option1: {
                title: {
                    text: "Overall Attendance",
                    left: "center",
                },
                color: ["#FF5F00", "#002379"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Attended", "Total"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "15%",
                    left: "15%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Teaching Days",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Attended",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Total",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            option2: {
                title: {
                    text: "Overall Quiz Performance",
                    left: "center",
                },
                color: ["#d90429", "#2b2d42"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Obtained Marks", "Total Marks"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Marks",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Obtained Marks",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Total Marks",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            option3: {
                title: {
                    text: "Overall Homework Performance",
                    left: "center",
                },
                color: ["#219ebc", "#2b9348"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    //data: ["Obtained Marks", "Total Marks"],
                    data: ["Total Homework Submissions", "Total Homeworks"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Homeworks",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Total Homework Submissions",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Total Homeworks",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            option5: {
                title: {
                    text: "Fees Summary",
                    left: "center",
                },
                color: ["#f86624", "#43bccd", "#662e9b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Total Fees", "Paid Fees", "Balance Fees"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Amount in Rs.",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Total Fees",
                        data: [],
                        type: "bar",
                        barGap: "45%",
                        label: {
                            show: true,
                            position: "insideTop",
                            rotate: 90
                        },
                    },
                    {
                        name: "Paid Fees",
                        data: [],
                        type: "bar",
                        barGap: "45%",
                        label: {
                            show: true,
                            position: "insideTop",
                            rotate: 90
                        },
                    },
                    {
                        name: "Balance Fees",
                        data: [],
                        type: "bar",
                        barGap: "45%",
                        label: {
                            show: true,
                            position: "insideTop",
                            rotate: 90
                        },
                    },
                ],
            },
            chart: {
                title: {
                    text: "Subjectwise Performance",
                    left: "center",
                },
                color: ["#764dff"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["ES101: English Grade VII"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: ["Class Test 1", "Term 1", "Class Test 2", "Term 2"],
                    axisLabel: {
                        margin: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Marks in %",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "ES101: English Grade VII",
                        data: [80, 65, 72, 55],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            chart_1: {
                title: {
                    text: "Subjectwise Performance",
                    left: "center",
                },
                color: ["#00f5d4", "#fee440", "#00bbf9", "#f15bb5"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Class Test 1", "Term 1", "Class Test 2", "Term 2"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [
                        "Grade I\nCS101:English",
                        "Grade I\nIT2001:Mathematics",
                        "Grade II\nIT2002:Marathi",
                        "Grade II\nIT2001:Social Science",
                        "Grade III\nIT2003:Hindi",
                        "Grade III\nIT2003:Computer",
                        "Grade IV\nCS102:Hindi",
                        "Grade IV\nCS103:History",
                    ],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Mark in %",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Class Test 1",
                        data: [80, 75, 65, 70, 61, 85, 82, 90],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Term 1",
                        data: [65, 70, 75, 80, 79, 55, 90, 65],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Class Test 2",
                        data: [0, 0, 55, 60, 62, 61, 78, 75],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Term 2",
                        data: [55, 65, 62, 58, 72, 75, 70, 80],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            chart_2: {
                title: {
                    text: "CS101:DS - Subject Range Analysis",
                    left: "center",
                },
                color: ["#ef6351"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Student#"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: ["A+", "A", "B+", "B", "C+", "C", "D+", "D", "F"],
                    axisLabel: {
                        margin: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Student#",
                        data: [65, 70, 74, 79, 80, 55, 90, 65, 120],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            chart1: {
                title: {
                    text: "Total Attendance",
                    left: "center",
                },
                color: ["#89c26d", "#383f51"],
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                },
                series: [
                    {
                        name: "Attendance",
                        type: "pie",

                        data: [],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            },
            chart2: {
                title: {
                    text: "Quiz Performance",
                    left: "center",
                },
                color: ["#38a3a5", "#22577a"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Obtained Marks", "Total Marks"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Marks",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Obtained Marks",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Total Marks",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            chart3: {
                title: {
                    text: "Subjectwise Homework performance",
                    left: "center",
                },
                color: ["#d81159", "#218380"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Total Homeworks Submitted", "Total Homeworks"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Homeworks",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Total Homeworks Submitted",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                    {
                        name: "Total Homeworks",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            chart3_1: {
                title: {
                    text: "Assignment Marks",
                    left: "center",
                },
                color: ["#3bceac"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["CS101: Data Structures FY"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "A10"],
                    axisLabel: {
                        margin: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Obtained Marks",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "CS101: Data Structures FY",
                        data: [8, 7, 4, 3, 10, 5, 3, 9, 8, 10],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
            chart5: {
                title: {
                    text: "Fees Summary",
                    left: "center",
                },
                color: ["#fb8500", "#023047"],
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                },
                series: [
                    {
                        name: "Fees",
                        type: "pie",

                        data: [
                            { value: 10000, name: "Paid Fees" },
                            { value: 36920, name: "Due Fees" },
                        ],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            },
            crs_ay_data: {
                color: ["#f86624"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                        // dataView: {
                        //     show: true,
                        //     title: "Data View",
                        //     readonly: false,
                        // },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Growth", "Budget 2011", "Budget 2012"],
                    itemGap: 5,
                },
                grid: {
                    top: "12%",
                    // left: '1%',
                    // right: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 75,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "Course",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Count",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        data: [],
                        value: [],
                        type: "bar",
                    },
                ],
            },
        }),
        components: {
            epsHeader: epsHeader,
        },
        methods: {
            async onStandardChange() {
                this.loading5 = true;
                const data = { learner: this.child };

                try {
                    const res = await axios.post("/Analytics/getStandardSubjectMapping", data);
                    if (res.data.flag === "YES") {
                        this.mappingData = res.data.standard_subject_mapping || [];

                        // Populate standard list
                        this.student_standard_list = this.mappingData.map(s => ({
                            standard_name: s.standard_name,
                            ldiv_id: s.ldiv_id
                        }));

                        // Find selected standard's subjects
                        let selectedStandard = this.mappingData.find(
                            s => s.ldiv_id === this.ldiv_id
                        );

                        if (selectedStandard) {
                            this.student_course_list = selectedStandard.subjects ? [...selectedStandard.subjects] : [];


                            if (this.student_course_list.length > 1) {
                                this.student_course_list.unshift({
                                    course_name: "All",
                                    course_id: "ALL",
                                    col_id: "ALL"
                                });
                            }
                        } else {
                            this.student_course_list = [];
                        }
                    } else if (res.data.flag === "UD") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                } finally {
                    this.loading5 = false;
                }
            },




            showFilters() {
                this.filtered = true;
                this.overall = false;

                if (this.selectedModule === "Attendance") {
                    this.attendance = true;
                } else if (this.selectedModule === "Examination") {
                    this.examination = true;
                } else if (this.selectedModule === "Quiz") {
                    this.quiz = true;
                } else if (this.selectedModule === "Homework") {
                    this.homework = true;
                } else if (this.selectedModule === "Course Framework") {
                    this.courseF = true;
                } else if (this.selectedModule === "Fees") {
                    this.fees = true;
                }
            },
            updateTitle(moduleName) {
                this.examination = false;
                this.attendance = false;
                this.quiz = false;
                this.homework = false;
                this.courseF = false;
                this.fees = false;

                if (moduleName == "Attendance") {
                    this.attendance = true;
                } else if (moduleName == "Quiz") {
                    this.quiz = true;
                } else if (moduleName == "Homework") {
                    this.homework = true;
                } else if (moduleName == "Course Framework") {
                    this.courseF = true;
                } else if (moduleName == "Fees") {
                    this.fees = true;
                } else if (moduleName == "Examination") {
                    this.examination = true;
                }
                this.selectedModule = moduleName;
                this.resetFilters();
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            },
            fetchData() {
                this.modules = true;
            },
            resetFilters() {
                this.ldiv_id = "";
                this.sem = "";
                this.assessment = "";
                this.col_id = "";
                this.feetype = "";
                this.overall = false;
                this.filtered = false;
                this.apply4 = false;
                this.apply1 = false;
                this.apply3 = false;
                this.apply5 = false;
            },
            async getStudentExamData() {
                this.overall = true;
                this.filtered = false;
                this.loading5 = true;
                const data = {
                    learner: this.child,
                };
                try {
                    const res = await axios.post("/Analytics/getChildExaminationAnalytics", data);

                    if (res.data.flag == "YES") {
                        if (res.data.bar_graph_details[0].length === 0 || res.data.bar_graph_details[1].length === 0) {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        }
                        else {
                            this.examination_graph = res.data.bar_graph_details
                            this.option.xAxis.data = this.examination_graph[1];
                            this.option.series[0].data = this.examination_graph[0];
                        }
                    }
                    else if (res.data.flag == "UD") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    }
                    else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
                    }
                    this.loading5 = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
                    this.loading5 = false;
                } finally {
                    this.loading5 = false;
                }
            },
            onLoad() {
                axios
                    .post("Analytics/analyticsHome")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.child_list = res.data.learner_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
            async getStudentAttendanceData() {
                // alert("Fetching Attendance Data...");
                this.overall = true;
                this.filtered = false;
                this.loading1 = true;
                const data = {
                    learner: this.child,
                };
                try {
                    const res = await axios.post("/Analytics/getChildAttendanceAnalytics", data);

                    if (res.data.flag == "YES") {
                        // alert(res.data.standards)
                        this.student_standard_list = res.data.student_standard_list;
                        this.semester_list = res.data.semester_list;
                        this.assessment_type_list = res.data.assessment_type_list;

                        const attended = res.data.data.map((stdData) => stdData ? stdData[0].present : null);
                        const total = res.data.data.map((stdData) => stdData ? stdData[0].total_working_stud : null);
                        // console.log("attende "+ attended + "total "+ total);
                        this.option1.xAxis.data = res.data.standards;
                        this.option1.series[0].data = attended;
                        this.option1.series[1].data = total;
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                } finally {
                    this.loading1 = false;
                }
            },
            async getStudentPieData() {

                this.loader1 = true;
                const data = {
                    learner: this.child,
                    ldiv_id: this.ldiv_id,
                };
                if (this.tenant === 'wws') {
                    data.assessmentType = this.assessment;
                } else {
                    data.semester = this.sem;
                }

                try {
                    const res = await axios.post("/Analytics/getChildAttendanceAnalyticsForPieChart", data);
                    if (res.data.data[0] == null) {
                        this.showSnackbar("#b71c1c", "Data not found");
                        this.loader1 = false;
                        return;
                    }
                    if (res.data.flag == "YES" && res.data.data.length > 0) {
                        this.apply1 = true;
                        const data = res.data.data[0][0];
                        const presentPercent = data.total_working_stud ? ((data.present / data.total_working_stud) * 100).toFixed(2) : 0;
                        const absentPercent = data.total_working_stud ? ((data.absent / data.total_working_stud) * 100).toFixed(2) : 0;
                        const pieData = [
                            { value: data.present, name: `Present (${presentPercent}%)` },
                            { value: data.absent, name: `Absent (${absentPercent}%)` },
                        ];
                        this.chart1.series[0].data = pieData;

                        const presentCount = data.present || 0;
                        const totalCount = data.total_working_stud || 0;
                        this.attendanceRatio = `${presentCount} / ${totalCount}`

                        const standard = this.student_standard_list.find(item => item && item.ldiv_id === this.ldiv_id);
                        this.selectedStandard = standard ? standard.standard_name : "N/A";

                        if (this.tenant === "wws") {
                            const assessment = this.assessment_type_list.find(item => item && item.id === this.assessment);
                            this.selectedTerm = assessment ? assessment.name : "N/A";
                        } else {
                            const semester = this.semester_list.find(item => item && item.id === this.sem);
                            this.selectedTerm = semester ? semester.sem : "N/A";
                        }
                    }

                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong"); // show snackbar
                        this.apply1 = false;
                    }
                }
                catch (error) {
                    console.log(error)
                    // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.apply1 = false;
                } finally {
                    this.loader1 = false;
                }
            },
            async getStudentHomeworkData() {
                // alert("Fetching Homework Data...");
                this.overall = true;
                this.filtered = false;
                this.loading3 = true;
                const data = {
                    learner: this.child,
                };
                try {
                    const res = await axios.post("/Analytics/getChildHomeworkAnalytics", data);

                    if (res.data.flag == "YES") {
                        this.student_standard_list = res.data.student_standard_list;
                        this.semester_list = res.data.semester_list;
                        this.student_course_list = res.data.student_course_list;
                        this.student_course_list.unshift({ course_name: "All", col_id: null });
                        //  const subject = res.data.data.map((markData) => markData.subject);
                        const obtainedMarks = res.data.data.map((markData) => markData.marks_obtained);
                        const totalMarks = res.data.data.map((markData) => markData.total_marks);
                        // console.log("total marks" + totalMarks);
                        // console.log("obtained marks" + obtainedMarks);
                        // this.homeworkTableData = subjects.map((subject, index) => ({
                        //     subject: subject,
                        //     obtainedMarks: obtainedMarks[index] || 0,
                        //     totalMarks: totalMarks[index] || 10,
                        // }));
                        this.option3.xAxis.data = res.data.standards;
                        this.option3.series[0].data = obtainedMarks;
                        this.option3.series[1].data = totalMarks;
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar); // show snackbar
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong123..."); // show snackbar
                } finally {
                    this.loading3 = false;
                }
            },
            async getStudentHomeworkPieData() {

                this.loader3 = true;
                const data = {
                    ldiv_id: this.ldiv_id,
                    semester: this.sem,
                    col_id: this.col_id,
                };
                try {
                    const res = await axios.post("/Analytics/getChildHomeworkAnalyticsForPieChart", data);

                    if (res.data.flag == "YES" && res.data.data.length > 0) {
                        this.apply3 = true;
                        this.data = res.data.data;
                        this.studentCourseList = res.data.studentCourseList;
                        // const subject = res.data.data.map((item) => item.subject);
                        const totalMarks = res.data.data.map((item) => item.total_marks);
                        const marksObtained = res.data.data.map((item) => item.marks_obtained);
                        this.chart3.xAxis.data = [this.student_course_list.find((course) => course.col_id === this.col_id).course_name];
                        this.chart3.series[0].data = marksObtained;
                        this.chart3.series[1].data = totalMarks;
                    }
                    else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar); // show snackbar
                        this.apply3 = false;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Data not found");
                        this.apply3 = false;
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.apply3 = false;
                } finally {
                    this.loader3 = false;
                }
            },
            async getStudentQuizData() {
                // alert("Fetching Quiz Data...");
                this.overall = true;
                this.filtered = false;
                this.loading2 = true;
                const data = {
                    learner: this.child,
                };
                try {
                    const res = await axios.post("/Analytics/getChildQuizkAnalytics", data);

                    if (res.data.flag == "YES") {
                        // alert("hiii")
                        this.student_standard_list = res.data.student_standard_list;
                        this.semester_list = res.data.semester_list;
                        this.student_course_list = res.data.student_course_list;
                        const obtainedMarks = res.data.data.map((mData) => mData.marks_obtained);
                        const totalMarks = res.data.data.map((mData) => mData.total_marks);

                        this.option2.xAxis.data = res.data.standards;
                        this.option2.series[0].data = obtainedMarks;
                        this.option2.series[1].data = totalMarks;
                    }
                    if (res.data.flag == "No") {
                        alert("red", res.data); // show snackbar
                    }
                } catch (error) {
                    alert("Something went wrong..."); // show snackbar
                } finally {
                    this.loading2 = false;
                }
            },
            async getStudentQuizPieData() {
                this.apply2 = true;
                this.loader2 = true;
                const data = {
                    ldiv_id: this.ldiv_id,
                    semesters: this.sem,
                };
                try {
                    const res = await axios.post("/Analytics/getChildQuizAnalyticsForPieChart", data);

                    if (res.data.flag == "YES" && res.data.data.length > 0) {
                        // alert("hii")
                        const courseNames = this.student_course_list.map((course) => course.course_name);
                        const totalMarks = res.data.data.map((marksData) => marksData.total_marks);
                        const marksObtained = res.data.data.map((marksData) => marksData.marks_obtained);
                        // console.log("total marks" + totalMarks);
                        // console.log("obtained marks" + marksObtained);
                        // console.log("data "+ res.data.data);
                        this.chart2.xAxis.data = courseNames;
                        this.chart2.series[0].data = marksObtained;
                        this.chart2.series[1].data = totalMarks;
                    }
                    else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", "Something went wrong"); // show snackbar
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Data not found");
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                    this.loader2 = false;
                }
            },
            // async getAyCourseData(){
            //     this.loader4 = true;
            //     const data = {
            //         ldiv_id: this.ldiv_id,
            //     };
            //     try {
            //         const res = await axios.post("/Analytics/getChildAyCourseAnalytics", data);

            //         if (res.data.flag == "YES") {
            //             this.apply4 = true;
            //             this.bar_graph_details = res.data.bar_graph_details;
            //             this.crs_ay_data.xAxis.data = this.bar_graph_details[1];
            //             this.crs_ay_data.series[0].data = this.bar_graph_details[0];
            //         }
            //         if (res.data.flag == "No") {
            //             this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
            //             this.apply4 = false;
            //         }
            //         this.loader4 = false;
            //     } catch (error) {
            //         this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
            //         this.loader4 = false;
            //         this.apply4 = false;
            //     } finally {
            //         this.loader4 = false;
            //     }
            // },
            async getAyCourseData() {
                this.loader4 = true;
                const data = {
                    ldiv_id: this.ldiv_id,
                };
                try {
                    const res = await axios.post("/Analytics/getChildAyCourseAnalytics", data);

                    if (res.data.flag === "YES") {
                        this.apply4 = true;
                        this.bar_graph_details = res.data.bar_graph_details;

                        // Extracting names and values for the chart
                        const names = this.bar_graph_details.map(item => item.name);
                        const values = this.bar_graph_details.map(item => item.value);

                        // Updating chart data
                        this.crs_ay_data.xAxis.data = names;
                        this.crs_ay_data.series[0].data = values;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.apply4 = false;
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.apply4 = false;
                } finally {
                    this.loader4 = false;
                }
            },

            async getStudentCourseData() {
                // alert("Fetching Course Framework Data...");
                this.overall = true;
                this.filtered = false;
                this.loading5 = true;
                const data = {
                    learner: this.child,
                };
                try {
                    const res = await axios.post("/Analytics/getChildCourseFrameworkAnalytics", data);

                    if (res.data.flag == "YES") {
                        this.course_framework_data = res.data.circle_graph_details
                        this.student_standard_list = res.data.student_standard_list
                        var graph_data = [];
                        for (var i = 0; i < this.course_framework_data.length; i++) {
                            graph_data.push(this.course_framework_data[i]);
                        }
                        this.chart_crs_frm.series[0].data = graph_data;
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
                    }
                    this.loading5 = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
                    this.loading5 = false;
                } finally {
                    this.loading5 = false;
                }
            },
            async getStudentFeesData() {
                // alert("Fetching Fees Data...");
                this.overall = true;
                this.filtered = false;
                this.loading5 = true;
                const data = {
                    learner: this.child,
                };
                try {
                    const res = await axios.post("/Analytics/getChildFeesAnalytics", data);

                    if (res.data.flag == "YES") {
                        // alert("hiii")
                        this.student_standard_list = res.data.student_standard_list;
                        const totalFees = res.data.data.map((feeData) => feeData.total_fees);
                        const paidFees = res.data.data.map((feeData) => feeData.total_paid);
                        const balance = res.data.data.map((feeData) => feeData.balance);

                        this.option5.xAxis.data = res.data.standards;
                        this.option5.series[0].data = totalFees;
                        this.option5.series[1].data = paidFees;
                        this.option5.series[2].data = balance;
                    }
                    if (res.data.flag == "No") {
                        alert("red", res.data); // show snackbar
                    }
                } catch (error) {
                    alert("Something went wrong..."); // show snackbar
                } finally {
                    this.loading5 = false;
                }
            },
            getStudCrs(ldiv_id) {
                this.stud_crs_list = []
                this.stud_crs = null
                this.stud_crs_list = ldiv_id.stud_crs_list
            },
            async getExamData() {
                const data = {
                    learner: this.child,
                    std: this.ldiv_id.std_id,
                    stud_crs: this.stud_crs,
                    assessment: this.assessment,
                    sem: this.sem
                };
                try {
                    const res = await axios.post("/Analytics/getExamData", data);
                    if (res.data.flag == "YES") {
                        if (res.data.bar_graph_details[0].length === 0 || res.data.bar_graph_details[1].length === 0) {
                            this.showSnackbar("#b71c1c", "Data not found");
                            this.apply5 = false;
                        } else {
                            this.apply5 = true;
                            this.examination_exam_graph = res.data.bar_graph_details
                            this.option_exam.xAxis.data = this.examination_exam_graph[1];
                            this.option_exam.series[0].data = this.examination_exam_graph[0];
                            // this.grade_bar_graph_details = res.data.grade_bar_graph_details
                            // this.option_exam_grade.xAxis.data = this.grade_bar_graph_details[1];
                            // this.option_exam_grade.series[0].data = this.grade_bar_graph_details[0];
                        }
                    }
                    else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                        this.apply5 = false;
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.apply5 = false;
                } finally {
                    this.loading5 = false;
                }
            },
            async getStudStd() {
                const data = {
                    learner: this.child,
                };
                try {
                    const res = await axios.post("/Analytics/getChildStd", data);

                    if (res.data.flag == "YES") {
                        this.standard_list = res.data.standard_list
                        this.semester_list = res.data.semester_list
                        this.assessment_type_list = res.data.assessment_type_list
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong...");// show snackbar
                } finally {
                    this.loading5 = false;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.tenant = localStorage.getItem("EPS-tenant");
            this.onLoad();
        },
    };
</script>

<style scoped>
    .grade-table {
        width: 72%;
        border-collapse: collapse;
    }

    .grade-table th {
        width: 20%;
    }

    .grade-table td,
    .grade-table th {
        border: 2px solid navy;
        text-align: center;
    }

    .course-box {
        width: 150px;
        height: 80px;
        margin-left: 40px;
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        text-align: center;
        border-radius: 5px;
    }
</style>